import { defineStore } from "pinia";
import { RouteRecordRaw } from "vue-router";
import { asyncRoutes, baseRoutes } from "@/router";
import { Role } from "@/constants/role.constant";

interface IPermissionState {
  addedRoutes: Array<RouteRecordRaw>;
  allRoutes: Array<RouteRecordRaw>;
}

/**
 * ユーザーは特定のルートにアクセス権限が存在するかを判断
 */
const hasPermission = (route: RouteRecordRaw, role: Role) => {
  if (route.meta?.roles) {
    return (route.meta.roles as Role[]).includes(role);
  } else {
    return true;
  }
};
/**
 * ユーザーのアクセスできるルートを取得
 */
const filterAsyncRoutes = (asyncRoutes: Array<RouteRecordRaw>, role: Role) => {
  const res: Array<RouteRecordRaw> = [];
  asyncRoutes.forEach((route) => {
    const tempRoute: RouteRecordRaw = { ...route };
    if (hasPermission(tempRoute, role)) {
      if (tempRoute.children) {
        tempRoute.children = filterAsyncRoutes(tempRoute.children, role);
      }
      res.push(tempRoute);
    }
  });
  console.log("filtered route:", res);
  return res;
};

export const usePermissionStore = defineStore({
  id: "permission",
  state: (): IPermissionState => ({
    addedRoutes: [],
    allRoutes: [],
  }),

  getters: {
    getAddedRoutes() {
      return this.addedRoutes;
    },
    getAllRoutes() {
      return this.allRoutes;
    },
  },

  actions: {
    SetRoutes(routes: Array<RouteRecordRaw>) {
      this.addedRoutes = routes;
      this.allRoutes = baseRoutes.concat(routes);
    },
    async generateRoutes(role: Role) {
      let accessRoutes = null;
      try {
        accessRoutes = filterAsyncRoutes(asyncRoutes, role);
        this.SetRoutes(accessRoutes);
        console.log("generateRoutes action:", this);
        return accessRoutes;
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
});
